export const integraciones = {
    text1: "Integrationen.",
    text2: "Kontaktieren Sie die Entwickler, um eine Integration mit Ihrem",
    text3: "PMS",
    text4: "Kontakt",
    text5: "Integration anfragen",
    text6: "Erfasste Daten",
    text7: "Angaben zum Antragsteller",
    text8: "Name",
    text9: "Grund der Anfrage",
    text10: "Beschreiben Sie, warum Sie die Integration benötigen",
    text11: "Schließen",
    text12: "Integrationsanfrage senden",
    text13: "Erfolgreich registriert",
    text14: "Fehler bei der Anfrage",
};